// ScrollToTopButton — bouton flottant "retour haut de page".
// Apparaît après 300px de scroll ; remonte en douceur. Monté globalement.
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import "./ScrollToTopButton.css";

const ScrollToTopButton = () => {
  const { t } = useTranslation("common");
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 300);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (!visible) return null;

  return (
    <button
      type="button"
      className="scroll-top-btn"
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      aria-label={t('ui.backToTopFull')}
      title={t('ui.backToTop')}
    >
      ↑
    </button>
  );
};

export default ScrollToTopButton;
